import DialogTextField from './DialogTextField';
import DialogItemsField from './DialogItemsField';
import DialogNumberField from './DialogNumberField';
import DialogSelectField from './DialogSelectField';
import DialogCheckboxField from './DialogCheckboxField';
import DialogUploadField from './DialogUploadField';
import DialogStateField from './DialogStateField';
import DialogPhoneField from './DialogPhoneField';
import DialogPercentField from './DialogPercentField';
import DialogAmountField from './DialogAmountField';
import DialogDateField from './DialogDateField';
import Dialog2FAField from './Dialog2FAField';
import DialogEnableField from './DialogEnableField';
import DialogCryptoAmountField from './DialogCryptoAmountField';
import DialogCommissionsField from './DialogCommissionsField';
import EditorSelectField from './EditorSelectField';
import { DialogEntityField } from './DialogEntityField';
import DialogServerSearchField from './DialogServerSearchField';
import DialogSystemRoleField from './DialogSystemRoleField';
import DialogContextMultiSelect from './DialogContextMultiSelect';
import DialogRoleSelectField from './DialogRoleSelectField';
import DialogBigTextField from './DialogBigTextField';
import DialogDateTimeField from './DialogDateTimeField';
import DialogControllerSelectField from './DialogControllerSelectField';
import DialogStaticMultiSelect from './DialogStaticMultiSelect';
import DialogBalanceField from './DialogBalanceField';
import DialogTagsField from './DialogTagsField';
import DialogJsonField from './DialogJsonField';
import DialogSecretField from './DialogSecretField';
import DialogScraperSettingsJsonField from './DialogScraperSettingsJsonField';
import DialogGatewaySettingsField from './DialogGatewaySettingsField';
import DialogWalletRequisitesField from './DialogWalletRequisitesField';
import DialogFileField from './DialogFileField';
import DialogWalletRuleField from './DialogWalletRuleField';
import DialogGatewayRuleField from './DialogGatewayRuleField';
import DialogWalletOrderField from './DialogWalletOrderField';
// import DialogItemsControllers from './DialogItemsControllers';
// import DialogRulesField from './DialogRulesField';

const Fields = {
    Text: DialogTextField,
    // Only the grid links it to another grid; a dialog shows the value as text.
    Link: DialogTextField,
    Items: DialogItemsField,
    State: DialogStateField,
    Number: DialogNumberField,
    Select: DialogSelectField,
    Checkbox: DialogCheckboxField,
    // Grids render booleans with the 'Boolean' cell, and the editor used to have
    // no entry for it — FormField falls back to Fields.Text, so every boolean was
    // edited as a free-text box that happily produced the string "false".
    // Read-only booleans (isLocked, isFinalized) carry disableEditor and never
    // reach this map.
    Boolean: DialogCheckboxField,
    Upload: DialogUploadField,
    Phone: DialogPhoneField,
    Percent: DialogPercentField,
    Amount: DialogAmountField,
    Date: DialogDateField,
    DateTime: DialogDateTimeField,
    // A role permission's controller. It had no editor and fell back to a text
    // box that was also read-only, so a permission could not be created.
    ItemsControllers: DialogControllerSelectField,
    Dialog2FA: Dialog2FAField,
    Enable: DialogEnableField,
    CryptoAmount: DialogCryptoAmountField,
    CommissionsTotal: DialogCommissionsField,
    EditorSelect: EditorSelectField,
    Entity: DialogEntityField,
    ServerSearch: DialogServerSearchField,
    SystemRole: DialogSystemRoleField,
    SelectCombined: DialogSelectField,
    ContextMultiSelect: DialogContextMultiSelect,
    StaticMultiSelect: DialogStaticMultiSelect,
    EditableBoolean: DialogCheckboxField,
    RoleSelect: DialogRoleSelectField,
    BigText: DialogBigTextField,
    Balance: DialogBalanceField,
    Tags: DialogTagsField,
    // The grid has had a Json cell all along; this map did not, so FormField fell
    // back to a text box that posted a string where the API wants an object.
    Json: DialogJsonField,
    // A text box with a generate button, for credentials the operator
    // invents rather than receives. Registered in ../cells too: the grid's
    // Cells lookup has no Text fallback, so a cell name missing from it
    // throws the moment someone turns on displayGrid.
    Secret: DialogSecretField,
    // A gateway settings row's settings: the Json editor plus a Scenarios mode
    // that points each xscraper action at inline code or a saved scraper scenario.
    // Shares Json's validation rule (utils/fieldValidation) and, in ../cells,
    // its grid cell.
    ScraperSettingsJson: DialogScraperSettingsJsonField,
    // The same, plus a Form of the settings the row's driver reads for its kind,
    // as core describes them (GatewaySettingsPage loads the schemas), secrets
    // masked. Json's rule and cell.
    GatewaySettings: DialogGatewaySettingsField,
    // A wallet's receiverInfo: the Json editor, or the fields of its gateway's
    // requisites template when it names one. Json's validation rule and grid
    // cell, as ScraperSettingsJson.
    WalletRequisites: DialogWalletRequisitesField,
    // A file picked and held, not uploaded: the value is the File, and the
    // dialog's caller reads it into its own request (the payout confirm's
    // receipt). Upload, above, posts to /api/files as soon as one is chosen.
    File: DialogFileField,
    // A wallet rule's filterRule: the BigText editor plus the rule language's
    // help — its syntax and the variables the API lists. The grid shows it as
    // BigText, with the text cell.
    WalletRule: DialogWalletRuleField,
    GatewayRule: DialogGatewayRuleField,
    // A wallet rule's orderRule: columns picked from the orderable variables, or
    // the text with the order's syntax. The grid shows it with the text cell.
    WalletOrder: DialogWalletOrderField,
    // ItemsControllers: DialogItemsControllers
};

export default Fields;
